import listtree from '@/modules/zjrc/pages/information/newstype/listtree';
import news from '@/modules/zjrc/pages/information/news/list';
import menu from '@/modules/zjrc/pages/basics/menu/list';
import connection from '@/modules/zjrc/pages/basics/connection/list';
import slideshow from '@/modules/zjrc/pages/basics/slideshow/list';
import approvalprocess from '@/modules/zjrc/pages/basics/approvalprocess/list';
import users from '@/modules/zjrc/pages/users/users/list';
import personalMember from '@/modules/zjrc/pages/users/member/list';
import publicwelfare from '@/modules/zjrc/pages/material/publicwelfare/list';
import donation from '@/modules/zjrc/pages/donation/donation/list';
import donationmaterials from '@/modules/zjrc/pages/donation/donationmaterials/list';
import invoiceapply from '@/modules/zjrc/pages/material/invoiceapply/list';
import train from '@/modules/zjrc/pages/train/train/list';
import trainapply from '@/modules/zjrc/pages/train/trainapply/list';
import income from '@/modules/zjrc/pages/capital/income/list';
import classList from '@/modules/zjrc/pages/train/trainapply/classList';
import detailLifeGuard from '@/modules/zjrc/pages/train/trainapply/detail_lifeGuard';
import expenditure from '@/modules/zjrc/pages/capital/expenditure/list';
import rescue from '@/modules/zjrc/pages/rescue/list';
import sickgrant from '@/modules/zjrc/pages/rescue/sickgrant/list';
import donationstemcell from '@/modules/zjrc/pages/donation/donationstemcell/list';
import donationorgan from '@/modules/zjrc/pages/donation/donationorgan/list';
import implementproject from '@/modules/zjrc/pages/material/implementproject/list';
import projectexpend from '@/modules/zjrc/pages/material/implementproject/addprojectexpend/list';
import progress from '@/modules/zjrc/pages/material/implementproject/progress/list';
import backlog from '@/modules/zjrc/pages/workbench/backlog/list';
import backlogDone from '@/modules/zjrc/pages/workbench/done/list';
import analysistable from '@/modules/zjrc/pages/analysis/list';
import activitytype from '@/modules/zjrc/pages/volunteer/activitytype/list';
import recruit from '@/modules/zjrc/pages/volunteer/recruit/list';
import recruitapply from '@/modules/zjrc/pages/volunteer/recruitapply/list';
import volunteer from '@/modules/zjrc/pages/volunteer/volunteer/list';
import rescueactivity from '@//modules/zjrc/pages/rescueactivity/list';
import cloudSms from '@/modules/zjrc/pages/cloudSms/';
import visitor from '@/modules/zjrc/pages/visitor/index'
import instationSet from '@/modules/zjrc/pages/basics/approvalprocess/instationSet/list'
import instationMessage from '@/modules/zjrc/pages/basics/instation/list'
import machineMenu from '@/modules/zjrc/pages/machine/list'
import equipSetting from "@/modules/zjrc/pages/machine/equipSetting";
import slideList from "@/modules/zjrc/pages/machine/slideList";
import expendList from '@/modules/zjrc/pages/donation/expend/list'
import oplog from '@/modules/zjrc/pages/log/op/list'
import exlog from '@/modules/zjrc/pages/log/ex/list'

let routers = [
    {
        path: '/zjrc/cloudSms/list',
        component: cloudSms
    },
    {
        path: '/zjrc/rescueActivity/list',
        component: rescueactivity
    },
    {
        path: '/zjrc/volunteer/list',
        component: volunteer
    },
    {
        path: '/zjrc/volunteer/recruitApplyList',
        component: recruitapply
    },
    {
        path: '/zjrc/volunteer/recruitList',
        component: recruit
    },
    {
        path: '/zjrc/volunteer/typeList',
        component: activitytype
    },
    {
        path: '/zjrc/newstype/listtree',
        component: listtree
    },
    {
        path: '/zjrc/news/list',
        component: news
    },
    {
        path: '/zjrc/menu/list',
        component: menu
    },
    {
        path: '/zjrc/connection/list',
        component: connection
    },
    {
        path: '/zjrc/slideshow/list',
        component: slideshow
    },
    {
        path: '/zjrc/approvalprocess/list',
        component: approvalprocess
    },
    {
        path: '/zjrc/users/list',
        component: users
    },
    {
        path: '/zjrc/member/list',
        component: personalMember
    },
    {
        path: '/zjrc/publicwelfare/list',
        component: publicwelfare
    },
    {
        path: '/zjrc/donation/list',
        component: donation
    },
    {
        path: '/zjrc/donationmaterials/list',
        component: donationmaterials
    },
    {
        path: '/zjrc/invoiceapply/list',
        component: invoiceapply
    },
    {
        path: '/zjrc/train/list',
        component: train
    },
    {
        path: '/zjrc/trainapply/list',
        component: trainapply
    },
    {
        path: '/zjrc/income/list',
        component: income
    },
    {
        path: '/zjrc/expenditure/list',
        component: expenditure
    },
    {
        path: '/zjrc/trainapply/classList',
        component: classList
    },
    {
        path: '/zjrc/trainapply/detailLifeGuard',
        component: detailLifeGuard
    },
    {
        path: '/zjrc/rescue/list',
        component: rescue
    },
    {
        path: '/zjrc/sickgrant/list',
        component: sickgrant
    },
    {
        path: '/zjrc/donationstemcell/list',
        component: donationstemcell
    },
    {
        path: '/zjrc/donationorgan/list',
        component: donationorgan
    },
    {
        path: '/zjrc/implementproject/list',
        component: implementproject
    },
    {
        path: '/zjrc/backlogDone/list',
        component: backlogDone
    },
    {
        path: '/zjrc/backlog/list',
        component: backlog
    },
    {
        path: '/zjrc/implementproject/projectexpend/list',
        component: projectexpend
    },
    {
        path: '/zjrc/implementproject/progress/list',
        component: progress
    },
    {
        path: '/zjrc/pages/analysis/list',
        component: analysistable
    },
    {
        path: '/zjrc/pages/visitor',
        component: visitor
    },
    {
        path: '/zjrc/pages/instationSet/list',
        component: instationSet
    },
    {
        path: '/zjrc/pages/instationMessage/list',
        component: instationMessage
    },
    {
        path: '/zjrc/machine/menu',
        component: machineMenu
    },
    {
        path: '/zjrc/machine/equipSetting',
        component: equipSetting
    },
    {
        path: '/zjrc/machine/slideList',
        component: slideList
    },
    {
        path: '/zjrc/expend/list',
        component: expendList
    },
    {
        path: '/zjrc/log/oplog',
        component: oplog
    },
    {
        path: '/zjrc/log/exlog',
        component: exlog
    },
]


export default routers
